import { auth0Client } from '#/utils/auth/auth0Client';

export async function logoutLoader(): Promise<null> {
  await auth0Client.logout({
    logoutParams: {
      returnTo: window.location.origin,
    },
  });
  return null;
}
